<template>
  <v-app class="grey lighten-4">
    <NavBar v-if="$router.currentRoute.name !== 'home'" />

    <v-main class="backg">
      <router-view></router-view>
    </v-main>

    <v-snackbar
      v-model="refresh"
      v-if="message != ''"
      bottom
      right
      :timeout="3000"
      >{{ message }}</v-snackbar
    >

    <br />

    <v-footer app v-if="$router.currentRoute.name !== 'home'">
      <span>&copy; 2020 - Powered By IoT Application And Hardware AB</span>
    </v-footer>
  </v-app>
</template>

<script>
import NavBar from "@/components/NavBar";
import { mapActions, mapState } from "vuex";

export default {
  name: "App",

  components: {
    NavBar
  },

  data() {
    return {
      refresh: false,
      darkTheme: this.$vuetify.theme.dark,
      landing: false
    };
  },

  updated() {
    if (this.$router.currentRoute.name == "home") {
      this.landing = true;
    }
  },

  created() {
    this.clearAlert();
  },

  computed: {
    ...mapState("alert", ["active", "message"])
  },

  methods: {
    ...mapActions({ clearAlert: "alert/clear" })
  },

  watch: {
    message(val) {
      if (val) {
        this.refresh = true;
      } else {
        this.refresh = false;
      }
    },

    refresh(value) {
      if (value === false) this.clearAlert();
    }
  }
};
</script>

<style>
.backg {
  background-image: url("/background-orange.jpg");
  background-size: cover;
}
</style>
